import { useCallback, useState } from "react";

import { getState } from "../../state/store";
import { selectFailedCertificateDusns } from "../../state/selectors";

import { certificateAction, fileTypeConfigs, fileTypes, strCode } from "../../consts";
import { notificationService, s3FileService, t } from "../../services";
import { fileUtils } from "../../utils";
import { useCreateCertificates } from "./useCreateCertificates";
import { useCreateDeviceChangeHistoryRecord } from "../deviceChangeHistory/useCreateDeviceChangeHistoryRecord";

export const useDownloadCertificates = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { mutationCallback: createCertificates } = useCreateCertificates();
  const { mutationCallback: createDeviceChangeHistoryRecord } =
    useCreateDeviceChangeHistoryRecord();

  const fetchCallback = useCallback(async (dusns, certificateUrl) => {
    setError(null);
    setLoading(true);

    const failedDusns = selectFailedCertificateDusns()(getState());

    try {
      let fileUrl = certificateUrl;

      if (!fileUrl) {
        fileUrl = await createCertificates(dusns, { shouldFetchExisting: true });
      }

      const { file } = await s3FileService.downloadFile(
        fileUrl,
        fileTypeConfigs[fileTypes.zip].extensions[0]
      );

      if (file) {
        fileUtils.downloadFile(file, "certificates", "zip");

        const filteredDusns = failedDusns?.length
          ? dusns.filter((dusn) => !failedDusns?.includes(dusn))
          : dusns;

        createDeviceChangeHistoryRecord(filteredDusns, certificateAction.DOWNLOAD);
      }
    } catch (err) {
      setError(null);

      notificationService.showError({
        title: t(strCode.DOWNLOAD_CERTIFICATES_ERROR),
        message: err?.response?.data?.error ? err?.response?.data?.error : err?.toString()
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return { fetchCallback, loading, error };
};
